var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparationToolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7451 16.1286C15.5324 16.1286 11.7812 12.7104 11.7812 8.4976C11.7812 4.28482 15.5368 0.871094 19.7451 0.871094",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7467 0.875488H8.65759C4.42705 0.875488 1 4.30254 1 8.53307C1 12.7636 4.40929 16.1285 8.63539 16.1285H19.7467",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0733 16.1286C9.86048 16.1286 6.10938 12.7104 6.10938 8.4976C6.10938 4.28482 9.86492 0.871094 14.0733 0.871094",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.9574 11.3029C21.5044 11.3029 22.7585 10.0488 22.7585 8.50181C22.7585 6.95479 21.5044 5.70068 19.9574 5.70068C18.4104 5.70068 17.1562 6.95479 17.1562 8.50181C17.1562 10.0488 18.4104 11.3029 19.9574 11.3029Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparationToolIcon);
export default __webpack_public_path__ + "static/media/separation-tool-icon.10db4ebfed7bfb535d12dc9fe8c013f9.svg";
export { ForwardRef as ReactComponent };